// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"64fdbc33","472":"b893d078"}[chunkId] + ".chunk.js";
};